import axios from 'axios';
import * as GlobalConfig from './constant';

const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: GlobalConfig.API_STATIC_TOKEN,
};

export const getUUIDBaseDataAPI = async (dataObj) => {
    return await axios.post(GlobalConfig.GET_UUID_BASE_DATA, dataObj, { headers });
}

export const getScodeRedirectAPI = async (dataObj) => {
    return await axios.post(GlobalConfig.GET_SCODE_REDIRECT, dataObj, { headers });
}

export const sendOTPAPI = async (dataObj) => {
    return await axios.post(GlobalConfig.GET_OTP_URL, dataObj, { headers });
}

export const verifyOTPAPI = async (dataObj) => {
    return await axios.post(GlobalConfig.VERIFY_OTP_URL, dataObj, { headers });
}